import PopularTrips from './PopularTrips';
export default PopularTrips;